import { createFileRoute } from '@tanstack/react-router';
import { ProductType } from '@repo/database/browser';
import { ProductForm } from '@/pages/products/form/product-form';
import { PROTECTED, REGISTRY } from '@/lib/constants/routes';

// Route gemella di `products/new` ma col tipo pre-selezionato a SERVICE.
// È una route dedicata (non un search param) per non sporcare la search
// condivisa di `/registry`, che verrebbe inoltrata come filtro API dagli
// altri tab (Controparti/Dipendenti → `companies`).
export const Route = createFileRoute(
  '/protected/_layout/registry/_layout/products/new-service'
)({
  component: () => (
    <ProductForm
      returnUrl={`${PROTECTED}${REGISTRY}`}
      initialProductType={ProductType.SERVICE}
    />
  ),
});
